import React, {useState, useRef, useEffect, useCallback} from 'react'
import fuzzySearch from '../common/fuzzySearch'
import SelectSearch from "react-select-search";
import axios from "axios";
import {frequencyMonth,NewFrequencyOptionsAll, frequencyOptionsAll, frequencyOptionsDefault, frequencyWeek} from "../common/data/dataTools";

const SaveReport = props =>{
	const {baseUrl,publicUrl, accountLevel,SetSelectedFrequency,locality,setLocality,selectedFrequencyName,selectedFrequency, SaveReportPopUpClose,saveTestData,allActiveAddressModalOpen,settingDisplayLocality,submitButtonHidden,setSubmitButtonHidded,nextButtonHidden,setNextButtonHidden,frequencyText,setFreqencyText,displayClass,setDisplayClass,frequencyAmount,setFrequencyAmount,frequencyAmounts,setFrequencyAmounts,displayFrequencyAmount,setDisplayFrequencyAmount,setFrequencyAmountData} = props
    const bulkPageFrequencies = accountLevel === 'PRO' ? NewFrequencyOptionsAll : NewFrequencyOptionsAll
    const [frequency,setFreqency] = useState([])
    

	let todaysDate = new Date()
    let dateDayOfMonth = todaysDate.getDate();
    let dateDayOfWeek = todaysDate.getDay() + 1;


    const checkLocality = (e, locality) => {
    	console.log('in checkLocality')
    	setLocality(locality)
    }

    const submitFormClick = (e) =>{
    	e.preventDefault();
    	var data = {
    		'type':'search_simulator',
    		'country':saveTestData.country,
    		'state':saveTestData.state,
    		'city':saveTestData.city,
    		'suburb':'',
    		'suburb_type':'',
    		'address':saveTestData.address,
    		'zipcode':saveTestData.postcode,
    		'search_term':saveTestData.keyword,
    		'engine':'google',
    		'language':saveTestData.lang,
    		'freqency':selectedFrequencyName,
    		'frequencyAmount':frequencyAmount,
    		'addresses':'NEW',
    		'isLocal':locality
    	}
    	console.log(data);
    	// axios.post(baseUrl + 'search-simulator-save-screenshot',data).then(r=>{
    	// 	console.log('response',r);
    	// 	console.log(r.data);
    	// })
   //  	let ajaxUrl = baseUrl + 'append-new-added-keyword-address?country='+saveTestData.country+'&state='+saveTestData.state+'&city='+saveTestData.city+'&zipCode='+saveTestData.postcode+'&address='+saveTestData.address+'&keyword='+saveTestData.keyword+'&language='+saveTestData.lang;
 		// console.log(ajaxUrl);
 		// axios.get(ajaxUrl).then(
 		// 	setTimeout(
  	// 					() => SaveReportPopUpClose(), 
  	// 						5000
			// 		)
   //  	 	).catch(e => { console.log(e) }
   //  	 	)
    }


    const openAddressModal=(e)=>{
    	e.preventDefault();
    	console.log('freqency amount data : ',frequencyAmount);
    	console.log('locality data : ',locality);
    	console.log('selected freqency : ',selectedFrequency)
    	console.log('selectedFrequencyName : ',selectedFrequencyName)
    	SaveReportPopUpClose();
    	allActiveAddressModalOpen();
    }
	return(
		<div className="modal-new-style tools-page" id="saveReport">
            <div className="modal-dialog">
		        <div className="modal-content">
		            <div className="modal-header">
		            	<img src={publicUrl + 'img/mobile-moxie.png'} alt="" height="50"/>
                            <h3 className="modal-title" id="addCountrieslabel">
                                Save Test
                            </h3>
                        <button type="button" className="close" onClick={SaveReportPopUpClose}>
                            <i className="material-icons">clear</i>
                        </button>
		            </div>
		             <form method="post">
				        <div className="modal-body">				          
				            <div className="row">
				                <div className="col-md-12">
				           			<h3>
                							How often would you like to Save and Run this keyword/address combination?
              						</h3>
				                </div>
				                <div className="col-md-12">
				                	<div className="input-section mb-2">
				                {bulkPageFrequencies.map((item,i)=>(
										<div className="input-section mt-2">
		                                    <label className="radio-inline">
		                                        <input type="radio" 
		                                        onChange={(e) => settingDisplayLocality(item.value)}
		                                        name="SaveTest" id={"saveTest_"+item.value} 
		                                        value={item.value} 
                                                checked={item.value == selectedFrequency}

		                                        />
		                                        <span className="keywordLocalityFlex">{item.name}</span>
		                                    </label>
		                                </div>		                              
				                ))}
				                	</div>
				                </div>
				                <div className={"col-md-12 mt-3 " + (displayFrequencyAmount)} id="not_show_in_once_and_daily">
				                	<div className="row"> 
				                		<div className="col-md-5 col-lg-4">
				                			<p>
				                				<strong>
				                					{frequencyText}
				                				</strong>
				                			</p>
				                		</div>
				                		<div className="col-md-5 col-lg-4">
				                			<div className="input-section text-dark">
	                                                <SelectSearch
	                                                    value={frequencyAmount}
	                                                    options={frequencyAmounts}
	                                                    filterOptions={fuzzySearch}
	                                                    onChange = {(e)=>setFrequencyAmountData(e)}

	                                                />
	                                        </div>
				                		</div>
				                	</div>
				                </div>
				                <div className={"col-md-12 mt-3 " + (displayClass)} id="not_show_in_once_only">
				                	<p className="mt-2">
				                		<strong>
				                			How would you like to submit your keyword for tracking, local or non-local?
				                		</strong>
				                	</p>
				                		<div className="input-section">
		                                    <label className="radio-inline">
		                                        <input type="radio" name="saveReport" id="saveReport_0" value="local" onClick={(e) => checkLocality(e, e.target.value)} checked={locality === 'local'}/><span className="keywordLocalityFlex">Local<img src={publicUrl + 'img/icons/local.png'} className="ml-5" alt="Local" style={{width: 25}}/></span>
		                                    </label>
		                                </div>
		                                <div className="input-section">
	                                    	<label className="radio-inline">
	                                        	<input type="radio" name="saveReport" id="saveReport_1" value="nonlocal" onClick={(e) => checkLocality(e, e.target.value)} checked={locality === 'nonlocal'}/><span className="keywordLocalityFlex">Non-Local<img src={publicUrl + 'img/icons/nonlocal.png'} className="ml-5" alt="NonLocal" style={{width: 13}}/></span>
	                                        </label>
                                        </div>
				                </div>
				                <div className={"modal-footer mt-4"+ (submitButtonHidden)}>
				                	<button
			                            onClick={(e) => submitFormClick(e)}
			                            className={"btn btn-primary addKeywordBtn " + (submitButtonHidden)}>Submit
			                        </button>
			                         <button
			                            className={"btn btn-primary addKeywordBtn "+(nextButtonHidden)}
			                             onClick={(e) => openAddressModal(e)}
			                            >Next
			                        </button>
				                </div>
				            </div>
				        </div>
				    </form>
		        </div>
		    </div>
		</div>
	)
}

export default SaveReport